export const openMegaMenuDropdown = () => {//Your code here
  const header = document.querySelector('.main-header')
  const menuItems = document.querySelectorAll(
    '.main-header .jet-mega-menu-list > li'
  )

  const targetClassName = 'jet-mega-menu-item--hover'
  const headerClassName = 'opened-dropdown'

  const observerOptions = {
    attributes: true
  }

  const mutationCallback = (mutationList, observer) => {
    mutationList.forEach((mutation) => {
      if (!header) return
      const { target } = mutation
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        target.classList.contains(targetClassName)
      ) {
        header.classList.add(headerClassName)
      } else {
        header.classList.remove(headerClassName)
      }
    })
  }
  
  menuItems.forEach((item) => {
    const observer = new MutationObserver(mutationCallback)// Your code here
    observer.observe(item, observerOptions)
  })
}